<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5" style="margin-top: 2px">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 批量导出 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click="BatchExport()"
              >
                {{ $t("MaterialAnalyzeDetail.Fields.batch_export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategories
                    v-model="materialCategoriesSelected"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterials
                    v-model="materialSelected"
                    :material-categories="materialCategoriesSelected"
                  />
                </v-col>
                <!-- 供货编码 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="supplyCode"
                    v-model="options.supply_code"
                    @text="supplyCode = $event"
                    :label="$t('Materials.Fields.supply_code')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="supplier_material_analyze"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="8">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  {{ total_num | formatTwoDot }}
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  {{ $t("Global.money") }}
                  {{ total_price | formatMoney }}
                </td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialAnalyze.Fields.material_num_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ total_num | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialAnalyze.Fields.material_price_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ total_price | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>
            <!-- 客户名称 -->
            <template v-slot:item.name="{ item }">
              <span>
                {{ item.shop_name ? item.shop_name : item.stock_name }}
              </span>
            </template>
            <template v-slot:item.average_price="{ item }">
              {{ $t("Global.money")
              }}{{ (item.total_price / item.total_num) | formatMoney }}
            </template>
            <template v-slot:item.total_num="{ item }">
              {{ item.total_num | formatTwoDot }}
            </template>
            <template v-slot:item.total_price="{ item }">
              {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import { mapState } from "vuex";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherMaterialCategories from "@/components/plugins/SearcherMaterialCategories";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import MaterialAnalyze from "@/api/material_analyze";

const defaultOptions = {
  datetimeRadioSelected: "create",
  create_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  create_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  // detail_flg:1
  supplyCode: "",
};

export default {
  data: () => ({
    supplier_material_analyze: [],
    category_ids: [],
    material_ids: [],
    supplyCode: '',
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    materialSelected: [],
    materialCategoriesSelected: [],
    total_num: 0,
    total_price: 0,
  }),

  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherMaterialCategories,
    SearcherMaterials,
    SearcherKeyword,
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    accountUserName() {
      if (this.accountInfo && this.accountInfo.account_name)
        return this.accountInfo.account_name;
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialAnalyze"),
        disabled: false,
        href: "/material-analyze",
      },
      {
        text: i18n.t("Nav.materialAnalyzeDetail"),
        disabled: true,
        href: "/material-analyze",
      },
    ],
    datetimeRadios: () => [
      {
        key: "create",
        text: i18n.t("Delivery.Fields.created_time"),
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("MaterialAnalyzeDetail.Fields.name", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("MaterialAnalyzeDetail.Fields.category_name"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("Materials.Fields.supply_code"),
          align: "start",
          sortable: false,
          value: "supply_code",
        },
        {
          text: i18n.t("MaterialAnalyzeDetail.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("MaterialAnalyzeDetail.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("MaterialAnalyzeDetail.Fields.standards"),
          align: "start",
          sortable: false,
          value: "standard_name",
        },
        {
          text: i18n.t("MaterialAnalyzeDetail.Fields.average_price"),
          align: "end",
          sortable: false,
          value: "average_price",
        },
        {
          text: i18n.t("MaterialAnalyzeDetail.Fields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("MaterialAnalyzeDetail.Fields.total_num"),
          align: "end",
          sortable: false,
          value: "total_num",
        },
        {
          text: i18n.t("MaterialAnalyzeDetail.Fields.price"),
          align: "end",
          sortable: false,
          value: "total_price",
        },
      ];
    },
    ...mapState(["accountInfo", "accountUser"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("material_analyze", [
        "materialCategoriesSelected",
        "materialSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "materialCategoriesSelected":
                this.materialCategoriesSelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        supply_code: this.supplyCode
      });
      this.getMaterialAnalyzeFromAPI();
    },
    resetSearch() {
      this.materialCategoriesSelected = [];
      this.materialSelected = [];

      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getMaterialAnalyzeFromAPI() {
      this.loading = true;
      MaterialAnalyze.fetchOne(
        this.$route.params.id,
        Object.assign(this.options, { detail_flg: 1 })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.supplier_material_analyze =
              response.data.supplier_material_analyze;
            this.total_num = response.data.total_num;
            this.total_price = response.data.total_price;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    BatchExport() {
      MaterialAnalyze.batchDetailExport(
        this.$route.params.id,
        Object.assign(this.options, { detail_flg: 1, supplier_id: this.accountUser.supplier_id })
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getMaterialAnalyzeFromAPI();
        sessionStorage.setItem(
          "material_analyze-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 商品分类
    materialCategoriesSelected: {
      handler() {
        this.options.category_ids = this.materialCategoriesSelected
          ? this.materialCategoriesSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "stock_currents_detail-materialCategoriesSelected",
          JSON.stringify(this.materialCategoriesSelected)
        );
      },
    },
    // 商品
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "stock_currents_detail-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>